import React from 'react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
export function HeroSection() {
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  return <section id="hero" className="pt-4 pb-12 px-5" data-id="element-177">
      <div className="max-w-lg mx-auto flex flex-col items-center text-center animate-fade-in-up" data-id="element-178">
        {/* Eyebrow */}
        <div className="inline-block px-3 py-1 mb-6 rounded-full glass border-accent/30" data-id="element-179">
          <span className="text-xs font-bold tracking-widest text-accent uppercase" data-id="element-180">
            MÉTODO PROBADO EN CIUDAD 2026
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-181">
          ¿Siente que su perro entra en un estado de{' '}
          <strong className="text-accent" data-id="element-182">bloqueo</strong> y{' '}
          <strong className="text-accent" data-id="element-183">falta de foco</strong> en cuanto pisa
          la calle?
        </h1>

        {/* Hero Image */}
        <div className="w-full mb-8 relative" data-id="element-184">
          <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full -z-10 transform scale-90" data-id="element-185"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jbKKtR8zYbHRy1zEq9N1tf/mockup_nuevo.png" alt="DOG-CALM Pack Completo" className="w-full h-auto rounded-2xl shadow-2xl border border-teal/20" data-id="element-186" />
        </div>

        {/* Sub-headline */}
        <p className="text-lg text-white/70 mb-10 leading-relaxed" data-id="element-187">
          Activa el protocolo biológico de 7 días para silenciar el cortisol y
          recuperar una correa en sonrisa. Sin fuerza, sin tirones.
        </p>

        {/* Social Proof Bar */}
        <div className="w-full mb-4 py-2.5 px-4 rounded-full bg-white/5 border border-white/10" data-id="element-188">
          <p className="text-white/80 text-sm font-medium text-center" data-id="element-189">
            ⭐⭐⭐⭐⭐ +450 comentarios positivos esta semana.
          </p>
        </div>

        {/* CTA */}
        <div className="w-full flex flex-col items-center gap-3" data-id="element-190">
          <Button onClick={goToCheckout} fullWidth className="animate-pulse-soft" data-id="element-191">
            SÍ, QUIERO PASEOS EN CALMA - 9,95€
          </Button>
          <p className="text-white/70 text-sm font-medium" data-id="element-192">
            Pago único. Acceso inmediato. ⭐ 4.9/5 valoración real.
          </p>
        </div>
      </div>
    </section>;
}